import { cn } from 'lib/helpers/utility';

import DateRangeSelector from '../../DateRangeSelector/DateRangeSelector';

import InfiniteDropdown from './InfiniteDropdown';

const FilterValueTrigger = ({
  type,
  values,
  onChange,
  data,
  index,
  position,
  onWrongFilter,
  className,
  icon,
  text,
  active,
  // Button.Group's per-segment props (variant, size, isFirst, isLast, isGroup) reach the button here.
  ...groupProps
}) =>
  type === 'date-range' ? (
    <DateRangeSelector
      value={values}
      onChange={onChange}
      buttonIcon={icon}
      buttonClassName={className}
      emptyLabel={text}
      position={position}
      direction={data?.direction}
      dateOnly={data?.dateOnly}
    />
  ) : (
    <InfiniteDropdown
      items={values}
      data={data}
      dropdownClassName={cn(
        'absolute m-0 z-[100] shadow-xs',
        position === 'left' ? 'right-0' : 'left-0'
      )}
      onChange={onChange}
      active={active}
      text={text}
      icon={icon}
      iconColor="neutral"
      className={className}
      withButton
      index={index}
      onWrongFilter={onWrongFilter}
      {...groupProps}
    />
  );

export default FilterValueTrigger;
